module.exports = __webpack_public_path__ + "static/media/3Specialties.09e34d92.svg";